var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_730_5011)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 18.6561C35.0021 21.426 34.1826 24.1343 32.6451 26.4382C31.1076 28.7421 28.9212 30.5382 26.3626 31.5992C23.804 32.6602 20.9881 32.9384 18.2714 32.3985C15.5547 31.8587 13.0591 30.5251 11.1005 28.5665C9.14192 26.6079 7.80833 24.1123 7.26848 21.3956C6.72864 18.6788 7.0068 15.863 8.06777 13.3044C9.12874 10.7458 10.9248 8.55942 13.2288 7.0219C15.5327 5.48439 18.241 4.66485 21.0108 4.667C24.7201 4.66987 28.2766 6.14465 30.8995 8.7675C33.5223 11.3903 34.9971 14.9469 35 18.6561Z",
    fill: "#E16E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.334 12.1709L39.4881 15.0959L21.0859 44.6729",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9246 15.3364C22.6037 14.2133 23.6088 13.3237 24.8061 12.7859C26.0033 12.2482 27.336 12.0878 28.6266 12.3262C33.7526 13.6609 39.5032 15.1661 39.5032 15.1661L30.9837 28.8683L15.9609 25.0203L21.9246 15.3364Z",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9457 24.9497C15.4226 26.2183 14.4415 27.2437 13.1973 27.8224C11.9531 28.4011 10.5367 28.4907 9.22948 28.0735L0 25.688L8.17875 19.6676L8.51952 12L21.81 15.5356",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_730_5011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.25c8d6e09a6cc5f850070ea1801d90da.svg";
export { ForwardRef as ReactComponent };